import { InjectionToken } from '@angular/core';

/**
 * The visitor's IP, provided per request by the Express SSR server (projects/shop/server.ts).
 * During SSR it is the server, not the visitor, that calls the API, so the API cannot see the
 * visitor's IP by itself; it is forwarded in `X-Visitor-IP` so the API can resolve the country.
 * Not provided in the browser: always inject it with { optional: true }.
 */
export const VISITOR_IP = new InjectionToken<string | null>('VISITOR_IP');
